import { Button, ButtonGroup, Icon, Tab, TabId, Tabs } from "@blueprintjs/core";
import { assertNever } from "assert-never";
import React from "react";

import { DEMO_MODE, DEMO_MODE_DISABLED_TEXT } from "../DemoMode";
import styles from "./ToolsPanelTabs.module.css";

export interface ToolsPanelProps {
  tab: TabIdentifier;
  onTabChange: (tab: TabIdentifier) => void;
  onNewTerminalClick: () => void;
  onCloseTerminalClick: () => void;
}

export type TabIdentifier = "TERMINAL" | "DIAGNOSTICS" | "GHCI";

export function ToolsPanelTabs(props: ToolsPanelProps): JSX.Element {
  // const [selectedTab, setSelectedTab] = React.useState<TabIdentifier>("TERMINAL");

  const handleTabChange = React.useCallback(
    (newTabId: TabId) => {
      props.onTabChange.call(null, newTabId as TabIdentifier);
    },
    [props.onTabChange]
  );

  // const handleRef = React.useCallback((node: HTMLDivElement) => {
  //   const term = new Terminal();
  //   const fitAddon = new FitAddon();
  //   term.loadAddon(fitAddon);
  //   term.open(node);
  //   term.onResize((x, y) => {
  //     console.log("resize", x, y);
  //   });
  //   console.log("YEEE");
  //   term.write("Hello\r\n");
  //   term.write("http://www.yahoo.com\r\n");
  //   term.write("World\r\n");
  //   for (let i = 0; i < 1000; ++i) {
  //     term.write(`${i}\r\n`);
  //   }
  //   term.onData((x, y) => {
  //     console.log(typeof x, JSON.stringify(x), y);
  //   });
  //   fitAddon.fit();
  //   // node.style.background = "green";
  // }, []);

  return (
    <div className={styles.root}>
      <Tabs className={styles.tabs} selectedTabId={props.tab} onChange={handleTabChange}>
        <Tab id="TERMINAL">
          <Icon icon="console" /> Terminal
        </Tab>
        <Tab id="DIAGNOSTICS">
          <Icon icon="highlight" /> Diagnostics
        </Tab>
        <Tab id="GHCI">
          <Icon icon="play" /> GHCi
        </Tab>
      </Tabs>
      <div className={styles.toolbar}>
        {(() => {
          switch (props.tab) {
            case "TERMINAL":
              return (
                <TerminalToolbar
                  onNewTerminalClick={props.onNewTerminalClick}
                  onCloseTerminalClick={props.onCloseTerminalClick}
                />
              );
            case "DIAGNOSTICS":
              return <></>;
            case "GHCI":
              return <></>;
            default:
              return assertNever(props.tab);
          }
        })()}
      </div>
    </div>
  );
}

interface TerminalToolbarProps {
  onNewTerminalClick: () => void;
  onCloseTerminalClick: () => void;
}

function TerminalToolbar(props: TerminalToolbarProps): JSX.Element {
  return (
    <ButtonGroup>
      <Button
        title={"New Terminal" + (DEMO_MODE ? ` (${DEMO_MODE_DISABLED_TEXT})` : "")}
        icon="new-layers"
        disabled={DEMO_MODE}
        onClick={props.onNewTerminalClick}
      />
      <Button
        title={"Close Terminal" + (DEMO_MODE ? ` (${DEMO_MODE_DISABLED_TEXT})` : "")}
        icon="trash"
        disabled={DEMO_MODE}
        onClick={props.onCloseTerminalClick}
      />
    </ButtonGroup>
  );
}
